import React from 'react'
import About from '../3'
import { RealEstateDataPageComponentData } from 'types'
//Helpers
const AboutUs14 = ({
  title,
  subtitle,
  image_gatsby,
  titleElement,
  global_data,
  paragraphElement,
  titleSecondary,
  alignCenter,
  subtitleColor,
  subtitleHexa,
  titleColor,
  titleHexa,
}: RealEstateDataPageComponentData) => {
  return (
    <About
      title={title}
      subtitle={subtitle}
      image_gatsby={image_gatsby}
      titleElement={titleElement}
      global_data={global_data}
      paragraphElement={paragraphElement}
      titleSecondary={titleSecondary}
      alignCenter={alignCenter}
      subtitleColor={subtitleColor}
      subtitleHexa={subtitleHexa}
      titleColor={titleColor}
      titleHexa={titleHexa}
    />
  )
}

export default AboutUs14
